<div class="sla-container">
  <div class="sla-header">
    <div>
      <h2><i class="fa-solid fa-bolt-lightning"></i> Macros</h2>
      <p class="sla-sub">Canned replies agents insert into the ticket reply composer via /macro. Inserting a macro drops its content (with placeholders resolved) and applies its field changes. Scope to the whole org, a team, or a single agent.</p>
    </div>
    <button class="btn-primary" (click)="startCreate()" *ngIf="!isCreating">
      <i class="fa-solid fa-plus"></i> New Macro
    </button>
  </div>

  <div class="banner banner-error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="banner banner-success" *ngIf="successMessage">{{ successMessage }}</div>

  <!-- Create -->
  <div class="policy-card editing" *ngIf="isCreating">
    <ng-container *ngTemplateOutlet="macroForm; context: { form: createForm }"></ng-container>
    <div class="form-actions">
      <button class="btn-primary" (click)="saveCreate()" [disabled]="isSaving">Create</button>
      <button class="btn-ghost" (click)="cancelCreate()">Cancel</button>
    </div>
  </div>

  <div class="sla-loading" *ngIf="isLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading macros…</div>

  <div class="sla-empty" *ngIf="!isLoading && macros.length === 0 && !isCreating">
    <i class="fa-solid fa-bolt-lightning"></i>
    <p>No macros yet. Create one to give agents quick canned replies in the composer.</p>
  </div>

  <!-- Macro list -->
  <div class="policy-card" [class.editing]="d.isEditing" *ngFor="let d of macros">
    <div class="policy-row" *ngIf="!d.isEditing">
      <div class="policy-main">
        <span class="policy-name">{{ d.macro.Name }}</span>
        <span class="policy-meta">
          <span class="metric"><i class="fa-solid fa-layer-group"></i> {{ scopeLabel(d.macro) }}</span>
          <span class="metric" *ngIf="d.macro.FieldChanges"><i class="fa-solid fa-pen-to-square"></i> sets fields</span>
          <span class="metric"><i class="fa-solid fa-chart-simple"></i> used {{ d.macro.UsageCount }}×</span>
        </span>
      </div>
      <span class="status-chip" [class.inactive]="d.macro.Status !== 'Active'">{{ d.macro.Status }}</span>
      <div class="policy-actions">
        <button class="icon-btn" title="Edit" (click)="startEdit(d)"><i class="fa-solid fa-pen"></i></button>
        <button class="icon-btn danger" title="Delete" (click)="confirmDelete(d)"><i class="fa-solid fa-trash"></i></button>
      </div>
    </div>

    <div *ngIf="d.isEditing">
      <ng-container *ngTemplateOutlet="macroForm; context: { form: d.form }"></ng-container>
      <div class="form-actions">
        <button class="btn-primary" (click)="saveEdit(d)" [disabled]="isSaving">Save</button>
        <button class="btn-ghost" (click)="cancelEdit(d)">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- ===== shared macro form ===== -->
<ng-template #macroForm let-form="form">
  <div class="form-grid">
    <label>Name<input type="text" [(ngModel)]="form.name" placeholder="e.g. Refund acknowledgement" /></label>
    <label>Format
      <select [(ngModel)]="form.contentFormat">
        <option value="HTML">HTML</option>
        <option value="Text">Text</option>
      </select>
    </label>
    <label>Scope
      <select [(ngModel)]="form.scope">
        <option *ngFor="let s of scopes" [value]="s">{{ s }}</option>
      </select>
    </label>
    <label>Status
      <select [(ngModel)]="form.status">
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>
    </label>
    <label *ngIf="form.scope === 'Personal'">Owner
      <select [(ngModel)]="form.ownerPersonId">
        <option value="">— Person —</option>
        <option *ngFor="let p of people" [value]="p.ID">{{ personName(p.ID) }}</option>
      </select>
    </label>
    <label *ngIf="form.scope === 'Team'">Team
      <select [(ngModel)]="form.teamId">
        <option value="">— Team —</option>
        <option *ngFor="let t of teams" [value]="t.ID">{{ t.Name }}</option>
      </select>
    </label>
  </div>

  <div class="rule-section">
    <div class="rule-section-head"><span class="rule-section-title">Content</span></div>
    <textarea class="macro-textarea" [(ngModel)]="form.content" rows="5"
      placeholder="Hi {{'{{'}}requester.FirstName{{'}}'}}, regarding ticket {{'{{'}}ticket.IssueNumber{{'}}'}}…"></textarea>
    <p class="hint-line">Placeholders: {{'{{'}}requester.FirstName{{'}}'}}, {{'{{'}}ticket.IssueNumber{{'}}'}}, {{'{{'}}agent.FirstName{{'}}'}}, {{'{{'}}organization.Name{{'}}'}}</p>
  </div>

  <div class="rule-section">
    <div class="rule-section-head"><span class="rule-section-title">Field changes (optional)</span></div>
    <input type="text" class="macro-fieldchanges" [(ngModel)]="form.fieldChanges"
      placeholder='{"Status":"Resolved","Priority":"High"}' />
    <p class="hint-line">JSON applied to the ticket on insert. Supported: Status, Priority, Severity.</p>
  </div>
</ng-template>
